/**
 * Acesso da cliente pelo link mágico (/c/:token). Território creme.
 * Troca o token por uma sessão e leva para as aprovações. Sem senha, sem cadastro.
 */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import type { SessionDTO } from "@unik/shared";
import { api, ApiClientError } from "../lib/api";
import { useSession } from "../lib/session";
import { BrandMark } from "../ui/BrandMark";
import { FullScreenLoader } from "../ui/ProtectedRoute";

export function ClientAccess() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setSession } = useSession();
  const [error, setError] = useState<string | null>(null);
  const tried = useRef(false);

  useEffect(() => {
    if (tried.current) return; // StrictMode chama o efeito 2x no dev; só tentamos uma.
    tried.current = true;
    void (async () => {
      try {
        const s = await api.post<SessionDTO>("/auth/magic", { token });
        setSession(s);
        // Cliente novo (briefing ainda não enviado) cai direto no diagnóstico;
        // quem já respondeu vai para a área de aprovação.
        const briefing = await api
          .get<{ status: "draft" | "submitted" }>("/approval/briefing")
          .catch(() => ({ status: "submitted" as const }));
        navigate(briefing.status === "submitted" ? "/aprovacoes" : "/briefing", { replace: true });
      } catch (err) {
        setError(
          err instanceof ApiClientError ? err.message : "Não foi possível abrir seu acesso.",
        );
      }
    })();
  }, [token, navigate, setSession]);

  if (error === null) return <FullScreenLoader />;

  return (
    <div className="app-shell flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <div className="w-full max-w-sm">
        <BrandMark variant="vinho" className="mx-auto h-6" />
        <h1 className="type-h2 mt-4 text-text-cream">Acesso indisponível</h1>
        <p className="type-body mt-3 text-text-secondary">{error}</p>
        <p className="type-caption mt-6 text-text-tertiary">
          Peça um novo link para quem cuida do seu conteúdo.
        </p>
      </div>
    </div>
  );
}
